import formName from 'constants/formName'
import { actions, selectors } from 'data'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { WhitelistAddressFormType } from 'data/types'
import { call, put, select } from 'redux-saga/effects'
import { addWhitelistAddress } from 'services/api/payments'
import { Response } from 'utils/fetchApi'

import { goToStep } from './common'

export default function* addAddressStep(form: WhitelistAddressFormType) {
  const { address, memo, tag } = form
  let addressTagged: string | undefined

  // concat XLM memo or XRP tag if needed
  if (address !== undefined && memo !== undefined && memo.length > 0) {
    addressTagged = `${address}:${memo}`
  }
  if (address !== undefined && tag !== undefined && tag.length > 0) {
    addressTagged = `${address}:${tag}`
  }

  const twoFactorStatus = yield select(selectors.auth.getTwoFactorStatus)
  const challenge = yield select(
    selectors.auth.secondFactorChallenge.getCurrentSecondFactorChallenge
  )
  const apiAddress = addressTagged !== undefined ? addressTagged : address
  // If 2FA was WALLET_SMS we need to send the challenge id we requested while
  // rendering the form
  const challengeId =
    twoFactorStatus && twoFactorStatus[0] === 'WALLET_SMS' ? challenge?.challengeId : undefined
  const data: Response<void> = yield call(addWhitelistAddress, {
    ...form,
    address: apiAddress,
    challengeId
  })

  if (!data.ok) {
    yield call(notifyError, data.error && data.error.cause, 'KO_GENERIC')
    yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'loading', false))
    if (data.error && data.error.cause === 'Invalid 2FA') {
      yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'code', ''))
    }
    return
  }

  yield put(actions.payments.fetchWhitelistAddresses())
  yield call(notifySuccess, 'OK_WHITELIST_ADDED')

  yield put(actions.form.reset(formName.WHITELIST_ADDRESS))
  yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'loading', false))
  yield call(goToStep, 'listaddresses')
}
